<template>
<div class="ReTaskEnds">
	
	<div class="super_container" v-for="(taskend, obj_index) in value" :key="obj_index">
		
		<div class="md_inline_block">
			<input type="text" placeholder="Название" class="form-control" v-model.lazy="taskend.name">
		</div>
		<div class="md_inline_block">
			<el-select
				class="select-primary"
				size="large"
				placeholder="Тип завершения"
				v-model="taskend.end_type"
				filterable
				@change="onEndTypeChange(obj_index)"
			>
				<el-option
					v-for="(el_opt, el_index) in type_options"
					class="select-primary"
					:value="el_opt.value"
					:label="el_opt.label"
					:key="el_index"
				>
				</el-option>
			</el-select>
		</div>
		<div class="md_inline_block" v-if="taskend.end_type == 4"> 
			<div>
				<el-select
					class="select-primary"
					size="large"
					placeholder="Какой чеклист заполнить"
					v-model="taskend.checklist_id"
					filterable
					@change="onCheckListChange($event,obj_index)"
				>
					<el-option
						v-for="(el_opt, el_index) in checklist_options"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"
					>
					</el-option>
				</el-select>

				<div>
				<ReFormPrinterOptions v-for="(optField, obj_findex) in masCheckListParams[obj_index]" v-bind:key="obj_findex" :opt="optField" :isCollapseItem="true" :frmAllConfig="masCheckListParams[obj_index]"/>
				</div>
			</div>
		</div>
		
		<div class="md_inline_block" v-if="taskend.end_type == 8"> 
			<el-select
				class="select-primary"
				size="large"
				placeholder="Какую услугу создать"
				v-model="taskend.servicelist_id"
				filterable
				@change="onServiceListChange(obj_index)"
			>
				<el-option
					v-for="(el_opt, el_index) in servicelist_options"
					class="select-primary"
					:value="el_opt.value"
					:label="el_opt.label"
					:key="el_index"
				>
				</el-option>
			</el-select>
			
			
			
		</div>		
		
		<div class="md_inline_block" v-if="taskend.end_type == 8">  
			<el-select
				class="select-primary"
				size="large"
				placeholder="Результаты каких задачь передать"
				filterable
				v-model="taskend.transfer_result"
				:multiple="true"
			>
				<el-option
					v-for="(el_opt, el_index) in next_options"
					class="select-primary"
					:value="el_opt.value"
					:label="el_opt.label"
					:key="el_index"
				>
				</el-option>
			</el-select>
			<!-- v-model taskend.transfer_result: {{ taskend.transfer_result }} -->
		    <!-- el-select
				class="select-primary"
				size="large"
				placeholder="С каких задач стартовать новую услугу"
				v-model="start_new_bp_tasks"
				filterable
				:multiple="true"
				@change="onServiceListChange(obj_index)"
			>
				<el-option
					v-for="(el_opt, el_index) in servicelist_options"
					class="select-primary"
					:value="el_opt.value"
					:label="el_opt.label"
					:key="el_index"
				>
				</el-option>
			</el-select -->			
			
		</div>				
		
		<div class="md_inline_block">
			<el-select
				class="select-primary"
				size="large"
				placeholder="Задача после завершения"
				filterable
				v-model="taskend.tto"
				:multiple="true"
			>
				<el-option
					v-for="(el_opt, el_index) in next_options"
					class="select-primary"
					:value="el_opt.value"
					:label="el_opt.label"
					:key="el_index"
				>
				</el-option>
			</el-select>
		</div>
		<div class="md_inline_block">
			<div class="checkbox-radios">
				<base-radio v-for="(el_opt, el_index) in tType_options" :key="el_index+'_'+el_opt.name" :name="el_opt.name" v-model="taskend.ttype" inline>{{el_opt.label}}</base-radio>
			</div>
		</div>
		<div class="md_inline_block">
			<label class="col-form-label mr-2">Отправить услугу на контроль</label>
			<base-switch
				v-model="taskend.isOnControl"
				type="primary">
				<template v-slot:on><i class="tim-icons icon-check-2"></i></template>
				<template v-slot:off><i class="tim-icons icon-simple-remove"></i></template>
			</base-switch>
		</div>
		<div class="md_inline_block">
			<base-checkbox v-if="taskend.end_type == 4" v-model="taskend.sendKafka" >Отправлять исход в кафку(только для чеклистов)</base-checkbox>
			<base-checkbox v-if="taskend.end_type == 4" v-model="taskend.ReplaceKafkaBossIfAgentBoss" >Подменить ИД боса в секции документов кафка, если агент сам является босом(только для чеклистов)</base-checkbox>			
			
			
			<base-checkbox v-model="taskend.isVcard_template" >Отправлять текст визитки клиенту</base-checkbox>
					
			<template v-if="taskend.isVcard_template == true">
				{{taskend.vcard_popover}}
				<label class="col-form-label mr-2">Шаблон визитки</label>
				<textarea  class="form-control" v-model="taskend.vcard_template" placeholder="Шаблон визитки" ></textarea>

				<!-- <el-input
				class="form-control"
				type="textarea"
				:rows="2"
				placeholder="Шаблон визитки"
				v-model="taskend.vcard_template">
				</el-input> -->
			</template>
			
		    <div class="md_inline_block">
			<label class="col-form-label mr-2">Изменить статус родительской услуги при выполнении этого исхода</label>	
			<el-select 
		             class="select-primary"
		             size="large"
		             placeholder="Изменить статус родительской услуги при выполнении этого исхода"
		             v-model="taskend.ReplaceRootServStatus"
		             @change="ReplaceRootServStatus(obj_index)" >
			         <el-option
		                     v-for="el_opt in ReplaceRootServStatus_options"
		                     class="select-primary"
		                     :value="el_opt.value"
		                     :label="el_opt.label"
		                     :key="el_opt.value">
			         </el-option>
		        </el-select>
		    </div>
		    			
		</div>

		<div class="md_inline_block">
			<label class="col-form-label mr-2">Опубликовать?</label>
			<base-switch
				v-model="taskend.act"
				type="primary">
				<template v-slot:on><i class="tim-icons icon-check-2"></i></template>
				<template v-slot:off><i class="tim-icons icon-simple-remove"></i></template>
			</base-switch>
			<button v-if="taskend.id!=''" class="ml-2 btn btn-icon btn-simple btn-danger" @click="removeTaskEnd(taskend.id,obj_index)">
				<i class="tim-icons icon-trash-simple"></i>
			</button>
		</div>
	</div>
	<button class="btn btn-icon btn-simple btn-primary" @click="addEmptyTaskEnd()">
		<i class="tim-icons icon-simple-add"></i>
	</button>
</div>
</template>

<script>
	import Vue from 'vue';
	import { Select, Option } from 'element-ui';
	import { BaseRadio, BaseSwitch } from 'src/components/index';
	//import ReFormPrinterOptions from 'src/our_components/FormPrinter/ReFormPrinterOptions.vue';

	export default {
		name: 'ReTaskEnds',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
			BaseSwitch,
			BaseRadio,
			ReFormPrinterOptions: () => import('src/our_components/FormPrinter/ReFormPrinterOptions.vue'),
		},
		props: {
			value: Array,
			type_options: Array,
			next_options: Array,
			tType_options: Array,
			checklist_options: Array,
			servicelist_options: Array,
			vcard_popover: String
		},
		data () {
			return {
				ver: 2,
				masCheckListParams:[],
				isVcard_template:{value:false, elementType: 'checkbox', value_default: false},
				sendKafka:{value:false, elementType: 'checkbox', value_default: false},				
				ReplaceKafkaBossIfAgentBoss:{value:false, elementType: 'checkbox', value_default: false},				
				ReplaceRootServStatus_options:[{'value':'','label':'Нет'},{'value':'В архиве','label':'В архиве'},{'value':'В работе','label':'В работе'},{'value':'На контроле','label':'На контроле'},{'value':'Новая услуга','label':'Новая услуга'},{'value':'Сделка закрыта','label':'Сделка закрыта'}],
			}
		},
		watch: {
			masCheckListParams: {
				handler: function(new_val,old_val){
					// console.log('masCheckListParams:new_val,old_val',new_val,old_val); // прилетает всё состояние всего массива masCheckListParams

					let masJSON = [];
					let masVcard=[];

					for (let i = 0; i < new_val.length; i++) {
						const new_val_row = new_val[i];
						if(!new_val_row || !new_val_row.length) continue;
						const checklist_option=this.checklist_options.find(c=>c.value==this.value[new_val_row[0].val_id].checklist_id)
						if(!checklist_option) continue;
						let objDmp = this.$GVO.unlinkObject(checklist_option.JSON_PARAM);
						if(
							typeof new_val_row[0] != 'undefined'&& typeof new_val_row[0].elements != 'undefined' && new_val_row[0].elements.length>0){
							//debugger;
							//let objDmp = {'checklist_api':{'flt':{}}};
							// Найдём чеклист для текущей обработки и возьмём его json_param
							for (let z = 0; z < new_val_row[0].elements.length; z++) {
								const element = new_val_row[0].elements[z];
								objDmp.checklist_api.flt[element.elementGetParamMap] = this.$GVO.unlinkObject(element.element_model);
							}
						}
						masJSON[new_val_row[0].val_id] = objDmp;
						masVcard[new_val_row[0].val_id] = checklist_option.vcard_variables || '';
					}

					for (let y = 0; y < this.value.length; y++) {
						if(this.value[y].end_type=='4'){ // Заполнить чеклист
							this.value[y].JSON_PARAM = JSON.stringify(masJSON[y]);
							this.value[y].vcard_popover = masVcard[y] || this.vcard_popover;
						}else{
							this.value[y].vcard_popover = this.vcard_popover
						}
					}

					// console.log('masCheckListParams_value',this.value);
				},
				deep: true
			},
		},
		computed: {
			
		},
		methods: {
			addEmptyTaskEnd(){
				this.value.push({
					BP_TASK_ID: '',
					name: '',
					end_type: '',
					checklist_id: '',
					servicelist_id: '',					
					tto: '',
					act: true,
					ttype:'GOOD', // GOOD/OTHER
					id:'',
					JSON_PARAM:'',
					isOnControl: false,
					vcard_template: '',
					ReplaceRootServStatus: 'Нет',
				});
				this.masCheckListParams.push([]);
			},
			removeTaskEnd(tto_id,tto_ind){
				if(tto_id !=''){
					this.$GVO.ApiCall('DEL_TTO',{obj:'BP',flt:{id:tto_id}})
						.then((objApi) => {
							//console.log(objApi);
							if(objApi.success){
								this.value.splice(tto_ind,1);
							}
						})
						.catch(errorObjApi => console.error(errorObjApi));
				}
			},
			onEndTypeChange(obj_index){
				if(this.value[obj_index].end_type != 4){
					this.value[obj_index].checklist_id = '';
				}
				if(this.value[obj_index].end_type != 8){
					this.value[obj_index].servicelist_id = '';
				}				
			},
			ReplaceRootServStatus(obj_index){
			    // console.log(obj_index);
			},
			onCheckListChange(opt,obj_index){
				//Vue.set(this.masCheckListParams, obj_index, []);
				let masElements = [];

				for (let i = 0; i < this.checklist_options.length; i++) {
					if(this.checklist_options[i].value == opt){
						
						for (let x = 0; x < this.checklist_options[i].checklist_filters.length; x++) {
							let objElement = {};
							let param = this.$GVO.unlinkObject(this.checklist_options[i].checklist_filters[x].elementGetParamMap);
							if(typeof this.value[obj_index].JSON_PARAM =='string'){
								if(this.value[obj_index].JSON_PARAM>'')
									this.value[obj_index].JSON_PARAM = JSON.parse(this.value[obj_index].JSON_PARAM);
							}
							if(
								typeof this.value[obj_index].JSON_PARAM !='undefined'
								&& this.value[obj_index].JSON_PARAM != ''
								&& typeof this.value[obj_index].JSON_PARAM.checklist_api.flt[param] !='undefined'){
								objElement = this.$GVO.unlinkObject(this.checklist_options[i].checklist_filters[x]);
								objElement.element_model = this.$GVO.unlinkObject(this.value[obj_index].JSON_PARAM.checklist_api.flt[param]);
							}else{
								objElement = this.$GVO.unlinkObject(this.checklist_options[i].checklist_filters[x]);
							}
							masElements.push(objElement);
						}
						
					}
				}

				Vue.set(this.masCheckListParams, obj_index, [{val_id: obj_index, elements: masElements}]); // Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
			},
			onServiceListChange(obj_index){
				const serviceId=this.value[obj_index].servicelist_id;
				const list=this.servicelist_options.filter(v=>v.value==serviceId);
				if(list.length>0 && typeof list[0].JSON_PARAM != 'undefined'){
				    this.value[obj_index].JSON_PARAM = list[0].JSON_PARAM;
				}
			}			
		},
		mounted(){
			this.$nextTick(()=>{
				if(this.value && this.value.forEach)
					this.value.forEach((element,obj_index)=>{
						if(element.end_type==4){
							Vue.set(this.masCheckListParams, obj_index, []);
							if(element.JSON_PARAM){
								try{
									const j=JSON.parse(element.JSON_PARAM);
									if(j && j.checklist_api && j.checklist_api.flt){
										this.value[obj_index].JSON_PARAM = j;
									}
								}catch(e){

								}
							}
							this.onCheckListChange(element.checklist_id, obj_index);

						}
					});
			});
		},
	}
</script>
<style scoped>
	.ReTaskEnds .bootstrap-switch{ margin: 0px;}
	.ReTaskEnds .md_inline_block {align-self: start;}
	.ReTaskEnds .super_container{margin-bottom: 15px; border: 1px dashed #01B0E0; border-radius: 6px; padding: 10px; grid-gap: 10px;}
	.ReTaskEnds .form-options-group{width: 100%;}

</style>
